import type { CategoryOfAgentSystem, ElementCategory } from "./types";

const BY_AGENT_SYSTEM: Record<string, ElementCategory> = {
  lighting_general: "lighting",
  lighting_emergency: "emergencyLighting",
  power_socket: "sockets",
  machine_dedicated: "buildingServices",
  hvac_sanitary: "buildingServices",
  control_signal: "buildingServices",
  door_gate: "buildingServices",
  fire_alarm: "fireAlarm",
  smoke_extraction: "fireAlarm",
  intruder_alarm: "intruderAlarm",
  data_network: "data",
  earthing_bonding: "earthing",
  supply_feeder: "other",
  spare: "other",
  unknown: "other",
};

export const categoryOfAgentSystem: CategoryOfAgentSystem = (system) =>
  system ? (BY_AGENT_SYSTEM[system.trim().toLowerCase()] ?? null) : null;
